import React from "react"
export const ChevronRight = ({
  fill = "white",
  size = 40,
}: {
  fill?: string
  size?: number
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.667 29C14.417 28.722 14.285 28.3887 14.271 28C14.257 27.6113 14.389 27.292 14.667 27.042L21.708 19.958L14.625 12.875C14.375 12.625 14.257 12.2987 14.271 11.896C14.285 11.4933 14.417 11.167 14.667 10.917C14.9443 10.639 15.2707 10.5 15.646 10.5C16.0207 10.5 16.347 10.639 16.625 10.917L24.708 19C24.8473 19.1387 24.9447 19.2913 25 19.458C25.0553 19.6247 25.083 19.7913 25.083 19.958C25.083 20.1527 25.0553 20.3263 25 20.479C24.9447 20.6317 24.8473 20.7913 24.708 20.958L16.625 29C16.375 29.278 16.0557 29.41 15.667 29.396C15.2777 29.382 14.9443 29.25 14.667 29Z"
      fill={fill}
    />
  </svg>
)
